/**
 * Utility functions for the admin interface
 */

import { type ClassValue, clsx } from "clsx"
import { twMerge } from "tailwind-merge"

/**
 * Utility function for combining class names
 */
export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

/**
 * Cleans up author name by removing null values and extra spaces
 * @param authorName - The raw author name from the API
 * @returns Clean author name without null values
 */
export function cleanAuthorName(authorName: string | null | undefined): string {
  if (!authorName) return 'Anonymous';
  
  // Replace any occurrence of "null" with empty string
  let cleanName = authorName.replace(/null/gi, '').trim();
  
  // Replace multiple spaces with single space
  cleanName = cleanName.replace(/\s+/g, ' ');
  
  // If the result is empty or just whitespace, return Anonymous
  if (!cleanName) return 'Anonymous';
  
  return cleanName;
}

/**
 * Gets the first character of an author name for avatar display
 * @param authorName - The author name
 * @returns First character in uppercase
 */
export function getAuthorInitial(authorName: string | null | undefined): string {
  const cleanName = cleanAuthorName(authorName);
  return cleanName.charAt(0).toUpperCase();
}